// pages/GuestNamesPage.js — public page a ticket buyer opens from email to name their guests.  [marker: guest-names v1]
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({ baseURL: '/api/public' });
const BLUE = '#003897';
const wrap = { maxWidth: 640, margin: '0 auto', padding: '24px 16px 48px', fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif', color: '#1f2937' };
const card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginTop: 14 };
const input = { width: '100%', boxSizing: 'border-box', minHeight: 44, padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 16 };
const label = { display: 'block', fontSize: 13, color: '#4b5563', margin: '10px 0 4px' };

function fmtDate(d) { if (!d) return ''; const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/); const dt = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(d);
  return dt.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }); }

export default function GuestNamesPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [rows, setRows] = useState([]);
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/guest-names/${token}`)
      .then(r => { if (!r.data || !Array.isArray(r.data.tickets)) throw new Error('bad reply'); setData(r.data); setRows(r.data.tickets.filter(t => !t.is_buyer).map(t => ({ id: t.id, label: t.ticket_type_name, firstName: t.first_name || '', lastName: t.last_name || '', email: t.email || '' }))); })
      .catch(err => setError(err.response?.data?.error || 'This page could not be loaded. Please call NJJBA at 201-472-5120.'));
  }, [token]);

  const set = (i, k, v) => setRows(rs => rs.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const submit = async (e) => {
    e.preventDefault();
    const missing = rows.findIndex(r => !r.firstName.trim() || !r.lastName.trim());
    if (missing > -1) { setError(`Please enter a first and last name for guest ${missing + 1}.`); return; }
    setError(''); setSaving(true);
    try { await api.post(`/guest-names/${token}`, { tickets: rows }); setDone(true); window.scrollTo(0, 0); }
    catch (err) { setError(err.response?.data?.error || 'The names could not be saved. Please try again.'); }
    finally { setSaving(false); }
  };

  const buyer = data && data.tickets.find(t => t.is_buyer);
  return (
    <div style={{ background: '#f3f5f9', minHeight: '100vh' }}>
      <div style={{ background: BLUE, color: '#fff', padding: '16px' }}><div style={{ maxWidth: 640, margin: '0 auto', fontWeight: 600 }}>New Jersey Jewish Business Alliance</div></div>
      <div style={wrap}>
        {!data && !error && <p>Loading…</p>}
        {!data && error && <div style={card}><p style={{ margin: 0 }}>{error}</p></div>}
        {data && done && (
          <div style={card}>
            <h1 style={{ fontSize: 22, margin: '0 0 8px' }}>Thank you!</h1>
            <p style={{ margin: 0 }}>We have your guests' names for <strong>{data.event.name}</strong>. Their name tags will be ready at check-in. You can come back to this page to make changes.</p>
            <button type="button" onClick={() => setDone(false)} style={{ marginTop: 14, background: 'none', border: 0, color: BLUE, textDecoration: 'underline', fontSize: 15, padding: 0, cursor: 'pointer' }}>Edit the names</button>
          </div>
        )}
        {data && !done && (
          <form onSubmit={submit} noValidate>
            <h1 style={{ fontSize: 24, margin: '0 0 6px' }}>Who's coming?</h1>
            <p style={{ margin: 0, lineHeight: 1.5 }}>
              <strong>{data.event.name}</strong><br />{fmtDate(data.event.event_date)}{data.event.venue ? ` · ${data.event.venue}` : ''}
            </p>
            {buyer && <p style={{ margin: '12px 0 0', fontSize: 14, color: '#4b5563' }}>Ticket 1 is yours ({buyer.email}). Please enter the name of each guest using your other tickets.</p>}
            {rows.map((r, i) => (
              <div key={r.id} style={card}>
                <div style={{ fontWeight: 600 }}>Guest {i + 1} <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 13 }}>{r.label}</span></div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0 12px' }}>
                  <div><label style={label} htmlFor={`f${i}`}>First name</label><input id={`f${i}`} style={input} value={r.firstName} onChange={e => set(i, 'firstName', e.target.value)} autoComplete="off" /></div>
                  <div><label style={label} htmlFor={`l${i}`}>Last name</label><input id={`l${i}`} style={input} value={r.lastName} onChange={e => set(i, 'lastName', e.target.value)} autoComplete="off" /></div>
                </div>
                <label style={label} htmlFor={`e${i}`}>Guest's email (optional)</label>
                <input id={`e${i}`} type="email" style={input} value={r.email} onChange={e => set(i, 'email', e.target.value)} autoComplete="off" />
              </div>
            ))}
            {error && <p role="alert" style={{ color: '#b91c1c', marginTop: 14 }}>{error}</p>}
            <button type="submit" disabled={saving} style={{ marginTop: 18, width: '100%', minHeight: 48, background: BLUE, color: '#fff', border: 0, borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
              {saving ? 'Saving…' : 'Save guest names'}
            </button>
            <p style={{ fontSize: 13, color: '#6b7280', marginTop: 14 }}>Questions? Call 201-472-5120 or email info@njjba.com.</p>
          </form>
        )}
      </div>
    </div>
  );
}
